document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-mn-variant-id]');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.dataset.mnVariantId;
  const originalText = button.textContent;

  if (!variantId || button.classList.contains('is-loading')) return;

  button.classList.add('is-loading');
  button.textContent = '...';

  try {
    const root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Unable to add item');
    }

    await response.json();

    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.textContent = 'Added';

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

    setTimeout(() => {
      button.classList.remove('is-added');
      button.textContent = originalText;
    }, 1200);
  } catch (error) {
    button.classList.remove('is-loading');
    button.textContent = 'Error';

    setTimeout(() => {
      button.textContent = originalText;
    }, 1200);
  }
});